<template>
  <div v-if="$store.getters['loaderState'] == true">
    <div class="loader-container">
      <img src="/static/img/logo.svg" class="logo" />
      <div class="loader">
        <i></i>
      </div>
    </div>
    <div class="overlay">
      <i></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "Loader",
  props: ["visible"],
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_colors.scss";

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: $color1;
  z-index: 800;
}

.loader-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  z-index: 900;
  justify-content: center;
  align-items: center;
}

.logo {
  margin-bottom: 30px;
}

.loader {
  background-color: white;
  height: 85px;
  width: 85px;
  border-radius: 50%;
  text-align: center;
  i {
    display: block;
    margin: 0 auto;
    &:before {
      content: ".";
      animation-name: load;
      animation-duration: 800ms;
      animation-iteration-count: infinite;
      width: auto;
      color: $color1;
      display: inline-block;
      font-size: 40px;
    }
  }
}

@keyframes load {
  0% {
    content: ".";
  }
  33% {
    content: "..";
  }
  66% {
    content: "...";
  }
  100% {
    content: ".";
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Global/Loader.vue